module.exports = __webpack_public_path__ + "img/mechanical-arm.5ce839d4.jpg";